export const ZONES_LIST_KEY = 'zones_list'
export const TARIFF_LIST_KEY = 'tariff_list'
